import { useSelector } from 'react-redux';

import { IAppState } from 'config/redux/reducers';
import { TSessionArea } from '../types/sessionArea.types';
import { getSessionArea } from 'utils/getSelectedAddress.util';

const useSessionArea = (): [TSessionArea] => {
  const store = useSelector((state: IAppState) => state);
  return getSessionArea(store);
};

export default useSessionArea;
